import Swiper from 'swiper';
window.fit = window.fit || {};

(function($) {

  fit.Slider = function(root) {
    this.element = root;
    this._attach();
    $(window).on('resize',this._resize.bind(this));
    this._resize();
  }

  fit.Slider.prototype = {

    _attach : function() {

      var container = this.element.find('.js-slider-body').get()[0];
      var slider = this.slider = new Swiper(container, {
        direction: 'horizontal',
        slidesPerView: 'auto',
        wrapperClass : 'js-slider-items',
        slideClass : 'js-slider-item',
        observer: true,
        observeParents: true
      });
    },
    _resize : function() {
      // var offsetLeft = this.element.find('.js-slider-item:last-child').position().left;
      // var itemWidth = this.element.find('.js-slider-item').width();
      // var items = offsetLeft + itemWidth;
      // var sliderWidth = this.element.find('.js-slider-items').width() + 5;
      //
      // $(this.element).toggleClass('is-arrows', items > sliderWidth);
    }
  }

  $('.js-slider').each(function() {
    new fit.Slider($(this));
  })

})(jQuery);
